<template>
    <div>
        <slot :isReadonly="isReadonly" :getTouched="getTouched" :setTouched="setTouched" :setValue="setValue" :getError="getError" :getValue="getValue">
            <input @blur="setTouched" @input="setValue(value)" :value="getValue()" :placeholder="field" />
            <div v-if="touched">{{ error }}</div>
        </slot>
    </div>
</template>
<script>
let $parentForm = undefined;

function searchParentForm(component) {
    if (typeof component !== 'object' || component.$parent === undefined) {
        throw new Error("form-text doesn't have parent form");
    }

    return component.$parent.$options._componentTag === 'v-form'
        ? component.$parent
        : searchParentForm(component.$parent);
}

export default {
    name: 'form-control',
    props: {
        field: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            parentForm: searchParentForm.call(null, this),
        }
    },
    computed: {
        error() {
            return this.parentForm.getError(this.field);
        },
        value() {
            return this.parentForm.getValue(this.field);
        },
        touched() {
            return this.parentForm.getTouched(this.field);
        },
        readonly() {
            return this.parentForm.isReadonly();
        },
    }, 
    methods: {
        setTouched(touched = true) {
            this.parentForm.setTouched(this.field, touched);
        },
        setValue(value) {
            this.parentForm.setValue(this.field, value);
            this.setTouched(false);
        },
        getTouched() {
            return this.touched;
        },
        getError() {
            return this.error;
        },
        getValue() {
            return this.value;
        },
        isReadonly() {
            return this.readonly;
        }
    }
}
</script>


// WEBPACK FOOTER //
// FormControl.vue?9b5d2706